function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20.36 3.78l2.38-2.37a2.56 2.56 0 013.62 0l20.78 20.77a2.56 2.56 0 010 3.63L26.36 46.59a2.56 2.56 0 01-3.62 0l-2.37-2.37a2.57 2.57 0 01.04-3.67l12.88-12.27H2.57A2.56 2.56 0 010 25.7v-3.42a2.56 2.56 0 012.57-2.57h30.72L20.41 7.45a2.55 2.55 0 01-.04-3.67z",
  fillRule: "evenodd"
})));